// Angular imports
import { Component, OnInit, Input, ViewChild, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';

// CC-Common imports
import { Utils } from 'cc-common';

// 3rd party imports
import { DxPopupComponent } from 'devextreme-angular';

// Component imports
import { SearchCommunityComponent } from '../../search/search-community/search-community.component';
import { CommunitySelectorResultDto } from '../../_models/community-selector-result-dto';

// Service imports
import { ScreenService } from '../../_services/shared-services/screen.service';
import { HelperService } from '../../_services/shared-services/helper.service';

@Component({
    selector: 'app-community-quick-search',
    templateUrl: './community-quick-search.component.html',
    styleUrls: ['./community-quick-search.component.scss']
})
export class CommunityQuickSearchComponent implements OnInit, OnChanges {
    @ViewChild('searchCommunity', { static: false }) searchCommunityComponent: SearchCommunityComponent;
    @ViewChild('communityPopup', { static: false }) communityPopup: DxPopupComponent;

    @Input() searchText = '';
    @Input() lastSearchedText = '';
    @Input() searchResults: CommunitySelectorResultDto[] = [];
    @Input() searchTextClass = 'cc-search-text-input';
    @Input() placeholder = `Search Communities`;

    @Output() onTextSearched = new EventEmitter<string>();
    @Output() saveSearchResults = new EventEmitter<CommunitySelectorResultDto[]>();

    searchButton: object;

    isSmallScreen = false;
    popupVisible = false;
    popupWidth = '60%';
    popupHeight = '80%';

    loading = false;
    disableSearchText = false;

    constructor(private readonly screenService: ScreenService, private readonly helperService: HelperService) {}

    ngOnInit() {
        this.updateScreenSize();
        this.screenService.changed.subscribe(() => this.updateScreenSize());

        this.searchButton = {
            icon: 'fas fa-search',
            stylingMode: 'text',
            width: 32,
            height: 32,
            elementAttr: {
                class: 'cc-search-button'
            },
            onClick: () => {
                this.searchCommunities();
            }
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.searchText && changes.searchText.currentValue) {
            this.searchText = changes.searchText.currentValue;
        }
    }

    onCommunitySelect($event) {
        this.hide();
    }

    searchCommunities() {
        if (Utils.notNullOrEmpty(this.searchText) && this.searchText.length > 2) {
            this.disableSearchText = true; // ANG:- 2775 - To restrict user from modifying searchText after Enter key press. Enabling again once user closes community popup.
            this.loading = true;
            this.popupVisible = true;
            this.onTextSearched.emit(this.searchText);
        } else {
            this.helperService.getOkDialog('Error', 'Please provide at least 3 characters to search', 'Ok').show();
        }
    }

    hide(): void {
        this.disableSearchText = false;
        this.popupVisible = false;
    }

    populateCommunities(): void {
        if (this.searchText.length > 0) {
            setTimeout(() => {
                this.searchCommunityComponent.searchText = this.searchText;
                this.searchCommunityComponent.quickSearchText = this.lastSearchedText;
                this.searchCommunityComponent.communityList = this.searchResults;
                this.searchCommunityComponent.searchCommunity();
            }, 100);
            this.communityPopup.instance.repaint();
        }
    }

    saveLastSearchResult(event): void {
        // event emitted from searchCommunityComponent.searchCommunity() only if it's a quickSearch;
        if (event) {
            this.saveSearchResults.emit(event);
        }
        this.loading = false;
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
        if (this.isSmallScreen) {
            this.popupWidth = '95%';
            this.popupHeight = '90%';
        } else {
            this.popupWidth = '90%';
            this.popupHeight = '70%';
        }
    }

    public showLastSearchedResult(textToSearch: string): void {
        if (textToSearch) {
            this.searchText = textToSearch;
            if (this.searchText.length > 2) {
                this.popupVisible = true;
                this.loading = true;
            }
        }
    }
}
